import { render, staticRenderFns } from "./OpportunitiesListFilters.vue?vue&type=template&id=2b2b1c64&"
import script from "./OpportunitiesListFilters.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports